import { render, staticRenderFns } from "./Events_Diagnostics_View.vue?vue&type=template&id=4675e554&scoped=true&"
import script from "./Events_Diagnostics_View.vue?vue&type=script&lang=js&"
export * from "./Events_Diagnostics_View.vue?vue&type=script&lang=js&"
import style0 from "./Events_Diagnostics_View.vue?vue&type=style&index=0&id=4675e554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675e554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VRow,VTextarea})
